import { useSelector, useDispatch } from 'react-redux';
import { ThemesState } from '@core/components/src/withDevExtreme/redux/reducers';
import {
  toggleThemeLight,
  toggleThemeDark,
  toggleThemeLightCompact,
  toggleThemeDarkCompact
} from '@core/components/src/withDevExtreme/redux/actions';

export const useThemes = () => {
  const themesFromRedux = useSelector<{ themes: ThemesState }, ThemesState>(
    (state) => state.themes
  );
  const { darkTheme, darkCompactTheme, lightCompactTheme } = themesFromRedux;

  const dispatch = useDispatch();

  const setThemeLight = () => dispatch(toggleThemeLight());
  const setThemeDark = () => dispatch(toggleThemeDark());
  const setThemeLightCompact = () => dispatch(toggleThemeLightCompact());
  const setThemeDarkCompact = () => dispatch(toggleThemeDarkCompact());

  return {
    isDark: darkTheme || darkCompactTheme,
    isCompact: lightCompactTheme || darkCompactTheme,
    setThemeLight,
    setThemeDark,
    setThemeLightCompact,
    setThemeDarkCompact
  };
};
